export class CurriculumAnalysis {
  type: res.CurriculumAnalysis['type'] // 유형/단원. ENUM(CURRICULUM, CONCEPT)
  relationId: number // 유형/단원 ID. INT
  rate: number // 정답율. INT
  totalCount: number // 총 문제. INT
  correctCount: number // 정답. INT
  wrongCount: number // 오답. INT

  constructor(param: res.CurriculumAnalysis) {
    this.type = param.type
    this.relationId = param.relationId
    this.rate = param.rate
    this.totalCount = param.totalCount
    this.correctCount = param.correctCount
    this.wrongCount = param.wrongCount
  }
}
